// Scroll to Anchor
$(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        nav = $('header nav'),
        navHeight = nav.outerHeight(),
        $('html,body').animate({
          scrollTop: target.offset().top-navHeight+1
        }, 700);
        return false;
      }
    }
  });
});


// Mega Menu
function megaMenu() {
  $('.mega-menu__content > .flex').width($('.header__inline-menu').width()); 
}
function megaMenuToggle() {
  var closeMenuTimeout;
  var activeMenu = null;
  $('.mega-menu').each(function () {
    var menu = $(this);
    var menuContent = menu.find('.mega-menu__content');
    function openMenu() {
      clearTimeout(closeMenuTimeout);
      if (activeMenu && activeMenu[0] !== menu[0]) {
        activeMenu.removeAttr('open').find('.mega-menu__content').css('min-height', 0);
      }
      activeMenu = menu;
      menu.attr('open', true);
      let $submenu = menu.find('.mega-menu__link--level-2+ul');
      let $clone = $submenu.clone().css({
        visibility: 'hidden',
        display: 'block',
        position: 'absolute'
      }).appendTo('body');
      let height = $clone.outerHeight();
      $clone.remove();
      menuContent.css('min-height', height + 3);
    }
    function closeMenu() {
      closeMenuTimeout = setTimeout(function () {
        menu.removeAttr('open');
        menuContent.css('min-height', 0);
        if (activeMenu && activeMenu[0] === menu[0]) {
          activeMenu = null;
        }
      }, 200);
    }
    menu.on('mouseenter', openMenu);
    menuContent.on('mouseenter', openMenu);
    menu.on('mouseleave', closeMenu);
    menuContent.on('mouseleave', closeMenu);
  });
}


// Menu Drawer
function menuDrawer() {
  console.log('drawer');
  $('.menu-drawer__menu').css('margin-bottom', $('.menu-drawer-bottom').outerHeight());
};


// Img to SVG
!function(t,e){"use strict";function r(t){t=t.split(" ");for(var e={},r=t.length,n=[];r--;)e.hasOwnProperty(t[r])||(e[t[r]]=1,n.unshift(t[r]));return n.join(" ")}var n="file:"===t.location.protocol,i=e.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1"),o=Array.prototype.forEach||function(t,e){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;var r,n=this.length>>>0;for(r=0;n>r;++r)r in this&&t.call(e,this[r],r,this)},a={},l=0,s=[],u=[],c={},f=function(t){return t.cloneNode(!0)},p=function(t,e){u[t]=u[t]||[],u[t].push(e)},d=function(t){for(var e=0,r=u[t].length;r>e;e++)!function(e){setTimeout(function(){u[t][e](f(a[t]))},0)}(e)},v=function(e,r){if(void 0!==a[e])a[e]instanceof SVGSVGElement?r(f(a[e])):p(e,r);else{if(!t.XMLHttpRequest)return r("Browser does not support XMLHttpRequest"),!1;a[e]={},p(e,r);var i=new XMLHttpRequest;i.onreadystatechange=function(){if(4===i.readyState){if(404===i.status||null===i.responseXML)return r("Unable to load SVG file: "+e),n&&r("Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver."),r(),!1;if(!(200===i.status||n&&0===i.status))return r("There was a problem injecting the SVG: "+i.status+" "+i.statusText),!1;if(i.responseXML instanceof Document)a[e]=i.responseXML.documentElement;else if(DOMParser&&DOMParser instanceof Function){var t;try{var o=new DOMParser;t=o.parseFromString(i.responseText,"text/xml")}catch(l){t=void 0}if(!t||t.getElementsByTagName("parsererror").length)return r("Unable to parse SVG file: "+e),!1;a[e]=t.documentElement}d(e)}},i.open("GET",e),i.overrideMimeType&&i.overrideMimeType("text/xml"),i.send()}},h=function(e,n,a,u){var f=e.getAttribute("data-src")||e.getAttribute("src");if(!/\.svg/i.test(f))return void u("Attempted to inject a file with a non-svg extension: "+f);if(!i){var p=e.getAttribute("data-fallback")||e.getAttribute("data-png");return void(p?(e.setAttribute("src",p),u(null)):a?(e.setAttribute("src",a+"/"+f.split("/").pop().replace(".svg",".png")),u(null)):u("This browser does not support SVG and no PNG fallback was defined."))}-1===s.indexOf(e)&&(s.push(e),e.setAttribute("src",""),v(f,function(i){if("undefined"==typeof i||"string"==typeof i)return u(i),!1;var a=e.getAttribute("id");a&&i.setAttribute("id",a);var p=e.getAttribute("title");p&&i.setAttribute("title",p);var d=[].concat(i.getAttribute("class")||[],"injected-svg",e.getAttribute("class")||[]).join(" ");i.setAttribute("class",r(d));var v=e.getAttribute("style");v&&i.setAttribute("style",v);var h=[].filter.call(e.attributes,function(t){return/^data-\w[\w\-]*$/.test(t.name)});o.call(h,function(t){t.name&&t.value&&i.setAttribute(t.name,t.value)});var g,m,b,y,A,w={clipPath:["clip-path"],"color-profile":["color-profile"],cursor:["cursor"],filter:["filter"],linearGradient:["fill","stroke"],marker:["marker","marker-start","marker-mid","marker-end"],mask:["mask"],pattern:["fill","stroke"],radialGradient:["fill","stroke"]};Object.keys(w).forEach(function(t){g=t,b=w[t],m=i.querySelectorAll("defs "+g+"[id]");for(var e=0,r=m.length;r>e;e++){y=m[e].id,A=y+"-"+l;var n;o.call(b,function(t){n=i.querySelectorAll("["+t+'*="'+y+'"]');for(var e=0,r=n.length;r>e;e++)n[e].setAttribute(t,"url(#"+A+")")}),m[e].id=A}}),i.removeAttribute("xmlns:a");for(var x,S,k=i.querySelectorAll("script"),j=[],G=0,T=k.length;T>G;G++)S=k[G].getAttribute("type"),S&&"application/ecmascript"!==S&&"application/javascript"!==S||(x=k[G].innerText||k[G].textContent,j.push(x),i.removeChild(k[G]));if(j.length>0&&("always"===n||"once"===n&&!c[f])){for(var M=0,V=j.length;V>M;M++)new Function(j[M])(t);c[f]=!0}var E=i.querySelectorAll("style");o.call(E,function(t){t.textContent+=""}),e.parentNode.replaceChild(i,e),delete s[s.indexOf(e)],e=null,l++,u(i)}))},g=function(t,e,r){e=e||{};var n=e.evalScripts||"always",i=e.pngFallback||!1,a=e.each;if(void 0!==t.length){var l=0;o.call(t,function(e){h(e,n,i,function(e){a&&"function"==typeof a&&a(e),r&&t.length===++l&&r(l)})})}else t?h(t,n,i,function(e){a&&"function"==typeof a&&a(e),r&&r(1),t=null}):r&&r(0)};"object"==typeof module&&"object"==typeof module.exports?module.exports=exports=g:"function"==typeof define&&define.amd?define(function(){return g}):"object"==typeof t&&(t.SVGInjector=g)}(window,document);
function img2svg() {
  var mySVGsToInject = document.querySelectorAll('img.svg');
  SVGInjector(mySVGsToInject);
}

// Expands
$(document).on('click', '.expand-btn', function() {
  $(this).toggleClass('expanded'); 
});

// Search Trigger
$(document).on('click', '#search-trigger', function() {
  $('.header__search summary').trigger('click');
});

// Lightbox
!function(e){var n={};function o(t){if(n[t])return n[t].exports;var r=n[t]={i:t,l:!1,exports:{}};return e[t].call(r.exports,r,r.exports,o),r.l=!0,r.exports}o.m=e,o.c=n,o.d=function(e,n,t){o.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:t})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,n){if(1&n&&(e=o(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)o.d(t,r,function(n){return e[n]}.bind(null,r));return t},o.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(n,"a",n),n},o.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},o.p="",o(o.s=0)}([function(e,n,o){"use strict";function t(e){for(var n=1;n<arguments.length;n++){var o=arguments[n];for(var t in o)e[t]=o[t]}return e}var r=function e(n,o){function r(e,o,r){if("undefined"!=typeof document){"number"==typeof(r=t({},n,r)).expires&&(r.expires=new Date(Date.now()+864e5*r.expires)),r.expires&&(r.expires=r.expires.toUTCString()),e=encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var i="";for(var u in r)r[u]&&(i+="; "+u,!0!==r[u]&&(i+="="+r[u].split(";")[0]));return document.cookie=e+"="+o+i}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],o={},t=0;t<n.length;t++){var r=n[t].split("="),i=r.slice(1).join("=");try{var u=decodeURIComponent(r[0]);if(o[u]=i,e===u)break}catch(e){}}return e?o[e]:o}},remove:function(e,n){r(e,"",t({},n,{expires:-1}))},withAttributes:function(n){return e(this.converter,t({},this.attributes,n))},withConverter:function(n){return e(t({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(n)},converter:{value:Object.freeze(o)}})}({path:"/"},{});n.a=r;
window.Cookies = n.a;
}]);
function closeLightbox() {
    $('.lightbox').removeClass('open');
    $('body').css('overflow', '');
}
function lightbox() {
    if (!$('.lightbox').length) return;
    var formSuccess = window.location.search.indexOf('signup=success') > -1;
    if (formSuccess) {
        $('.lightbox').addClass('open');
        $('body').css('overflow', 'hidden');
        Cookies.set('lightbox', 'true', { expires: 365, path: '/' });
        setTimeout(function() {
            closeLightbox();
            history.replaceState(null, '', window.location.pathname);
        }, 5000);
        return;
    }
    if (!$('body').hasClass('template-product') && !Cookies.get('lightbox')) {
        setTimeout(function() {
            $('.lightbox').addClass('open');
            $('body').css('overflow', 'hidden');
            Cookies.set('lightbox', 'true', { expires: 30, path: '/' });
        }, 3000);
    }
}
$('.lightbox, .lightbox .x').on('click', function() {
    closeLightbox();
});
$('.lightbox-content').on('click', function(e) {
    e.stopPropagation();
});


// Custom Words Product
function initCustomWords() {
  if ($('#custom-words').length === 0) {
    return;
  }
  window.updateQuantity = function() {
    const customText = $('#custom-words').val();
    const charCount = customText.length || 1;
    const unitPrice = getVariantPrice();
    const totalPrice = (charCount * unitPrice).toFixed(2);
    updateQuantityInput(charCount);
    updatePriceDisplay(totalPrice);
  };
  function getVariantPrice() {
    const priceText = $('.product .price-item.price-item--regular').text().trim();
    console.log('Price text:', priceText);
    const priceMatch = priceText.match(/[\d,\.]+/);
    if (priceMatch) {
      return parseFloat(priceMatch[0].replace(',', ''));
    }
    return 0;
  }
  function updateQuantityInput(charCount) {
    const $quantityInput = $('input[name="quantity"]');
    if ($quantityInput.length) {
      $quantityInput.val(charCount);
    }
  }
  function updatePriceDisplay(totalPrice) {
    const $priceDisplay = $('#custom-price-display');
    if ($priceDisplay.length) {
      $priceDisplay.text(`$${totalPrice}`);
    }
  }
  var customText = $('#custom-words'); 
  if (customText.length > 0) {
    const priceContainer = document.querySelector('.price-block');
    if (priceContainer) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            updateQuantity();
          }
        }
      });
      observer.observe(priceContainer, { 
        childList: true,
        subtree: true
      });
    }
  }
}
function customWords() {
  initCustomWords();
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.nodeName === 'QUICK-ADD-MODAL') {
            setTimeout(function() {
              initCustomWords();
            }, 100);
          }
        });
      }
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'open' && 
          mutation.target.nodeName === 'QUICK-ADD-MODAL') {
        if (mutation.target.hasAttribute('open')) {
          setTimeout(function() {
            initCustomWords();
          }, 100);
        }
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });
}




$(document).ready(function() {
  megaMenu();
  megaMenuToggle();
  menuDrawer();
  img2svg();
  lightbox();
  customWords(); // This now handles both initial load and modal detection
});

$(window).on('load', function() {
  lightbox();
});

$( window ).resize(function() {
  megaMenu();
  menuDrawer(); 
});




// Custom Events
if (window.location.pathname.includes('thank-you')) {
  Shopify.analytics.publish('generate_lead');
  //gtag('event', 'generate_lead');
  console.log('Generate Lead Event')
}
document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
        if (event.target.tagName.toLowerCase() === 'a' && event.target.href.includes('tel')) {
            Shopify.analytics.publish('phone_call');
            //gtag('event', 'phone_call');
            console.log('Phone Call Event')
        }
    });
});
